/* */ 
"use strict";
var root_1 = require('../util/root');
var Symbol = root_1.root.Symbol;
if (typeof Symbol === 'function') {
  if (Symbol.observable) {
    exports.$$observable = Symbol.observable;
  } else {
    if (typeof Symbol.for === 'function') {
      exports.$$observable = Symbol.for('observable');
    } else {
      exports.$$observable = Symbol('observable');
    }
    Symbol.observable = exports.$$observable;
  }
} else {
  exports.$$observable = '@@observable';
}
